
export function PageHeader({ children }: { children: React.ReactNode }) {
    return (
        <h1 className={"text-lg font-semibold text-gray-900 mb-3"}>
            {children}
        </h1>
    )
}

export function Header3({ children }: { children: React.ReactNode }) {
    return (
        <h1 className={" font-medium text-gray-900 mb-3"}>
            {children}
        </h1>
    )
}
